'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { color, borderRadius, shadow } from '../styles/tokens.stylex';
const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
  styles?: stylex.StyleXStyles;
  thumbStyles?: stylex.StyleXStyles;
}>(({
  styles,
  thumbStyles,
  ...props
}, ref) => <SwitchPrimitives.Root ref={ref} {...stylex.props(sx.root, styles)} {...props}>
    <SwitchPrimitives.Thumb {...stylex.props(sx.thumb, thumbStyles)} />
  </SwitchPrimitives.Root>);
Switch.displayName = SwitchPrimitives.Root.displayName;
const sx = {
  root: {
    k1xSpc: "xwz0xwf",
    kZKoxP: "xxk0z11",
    kzqmXN: "x187nhsf",
    kfiyM8: "xc26acl",
    kaIpWk: "x4dzasd",
    kmkexE: "x5gkzjs",
    kWkggS: "xrhgmaw x1t0ys9q",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xdh2fpr",
    kVAM5u: "x9r1u3d",
    kI3sdo: "xk2swo9",
    kSiTet: "x1hc1fzr xijokvz",
    kkrTdU: "x1ypdohk x1s07b3s",
    kg3NbH: "xnjsko4",
    $$css: true
  },
  thumb: {
    k1xSpc: "x1lliihq",
    kZKoxP: "x1qx5ct2",
    kzqmXN: "xw4jnvo",
    kaIpWk: "x4dzasd",
    kWkggS: "x7d3uan",
    kGVxlE: "x1xt9a6s",
    kmkexE: "x1jaox4c",
    kFhvOy: "x1lqcxt8",
    k3aq6I: "xbryuvx xafeib7",
    kfzvcC: "x47corl",
    $$css: true
  }
};
export { Switch };